import divideByThousand from '@r1-frontend/ui-react/components/costs/helpers/divideByThousand';
import { NBSP, RubleSymbol } from '@r1-frontend/ui-react/tokens/symbols';

type TMonthlyProps = {
    /**
     * Цена в месяц
     */
    monthly: boolean,
    annually?: never,
}

type TAnnuallyProps = {
    monthly?: never,
    /**
     * Цена в год
     */
    annually: boolean,
}

export type TFormatProps = TMonthlyProps | TAnnuallyProps;

const format = (cost: number | string, is?: TFormatProps) => {
    const period = !is ? '' : is.monthly ? '/мес' : '/год';

    return `${divideByThousand(cost)}${NBSP}${RubleSymbol}${period}`;
};

export default format;
